import {
    SET_APITRAFFIC_DASHBOARD_INSIGHT,
    CLEAR_APITRAFFIC_DASHBOARD_INSIGHT,
    GET_APITRAFFIC_DASHBOARD_INSIGHT_SUCCESS,
    GET_APITRAFFIC_DASHBOARD_INSIGHT_FAILED
} from '../../actions/type';

const initialStateAPITrafficDashboardInsight = { data: null, status: 'idle' };

export default function APITrafficDashboardInsightReducer(state = initialStateAPITrafficDashboardInsight, action) {
    const { type, data } = action;

    switch (type) {
        case SET_APITRAFFIC_DASHBOARD_INSIGHT:
            return {
                ...state,
                data,
            }
        case CLEAR_APITRAFFIC_DASHBOARD_INSIGHT:
            return {
                ...state,
                data: null,
            }
        case GET_APITRAFFIC_DASHBOARD_INSIGHT_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_APITRAFFIC_DASHBOARD_INSIGHT_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}